/* eslint-disable complexity */
import { compositionFunction as CallToActionComposition } from 'src/components/Common/@electron/CallToAction/composition';
import Composition from 'src/lib/HOC/Composition';
import SimpleCardsComponent from './index';
import { SimpleCardsSitecoreDataType } from './types';

const { compositionFunction, component } = Composition(SimpleCardsComponent)(
  ({ fields }: SimpleCardsSitecoreDataType) => {
    const CTA = CallToActionComposition({ fields });
    const prompt = fields?.Prompt?.value;
    const cards = fields?.Cards?.map((item: any) => ({
      iconSrc: item.fields?.icon?.value?.src,
      link: item.fields?.link?.value,
      title: item.fields?.title?.value || '',
      description: item.fields?.description?.value || '',
      hideCard: item.fields?.hideCard?.value,
    }));
    return { CTA, cards, prompt };
  }
);

export { compositionFunction };
export default component;
